import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminUsuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [editando, setEditando] = useState(null);
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState('');

  useEffect(() => { carregar(); }, []);

  function carregar() {
    api.get('/usuarios').then(setUsuarios).catch(() => {});
  }

  async function bloquear(id) {
    await api.patch(`/usuarios/${id}/bloquear`);
    carregar();
  }

  async function desbloquear(id) {
    await api.patch(`/usuarios/${id}/desbloquear`);
    carregar();
  }

  async function salvar(e) {
    e.preventDefault();
    setMsg('');
    try {
      await api.put(`/usuarios/${editando.id}`, form);
      setMsg('Usuário atualizado!');
      setEditando(null);
      carregar();
    } catch (err) {
      setMsg(err.message);
    }
  }

  return (
    <div>
      <h2 className="admin-title">Usuários</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      {editando && (
        <form onSubmit={salvar} className="admin-form">
          <h3>Editar Usuário: {editando.nome}</h3>
          <div className="form-row">
            <div className="form-group"><label>Nome</label><input value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} /></div>
            <div className="form-group"><label>E-mail</label><input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>WhatsApp</label><input value={form.whatsapp || ''} onChange={e => setForm({ ...form, whatsapp: e.target.value })} /></div>
            <div className="form-group"><label>Nova Senha (opcional)</label><input type="password" value={form.senha || ''} onChange={e => setForm({ ...form, senha: e.target.value })} placeholder="Deixe em branco para manter" /></div>
          </div>
          <div className="admin-actions">
            <button type="submit" className="btn btn-primary">Salvar</button>
            <button type="button" className="btn btn-secondary" onClick={() => setEditando(null)}>Cancelar</button>
          </div>
        </form>
      )}
      <div className="admin-table-wrap">
        <table>
          <thead><tr><th>Nome</th><th>E-mail</th><th>Cidade</th><th>Pontos</th><th>Status</th><th>Tipo</th><th>Ações</th></tr></thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id}>
                <td>{u.nome}</td>
                <td>{u.email}</td>
                <td>{u.cidade_nome || '—'}</td>
                <td>{u.pontos}</td>
                <td>{u.bloqueado ? <span className="badge badge-danger">Bloqueado</span> : <span className="badge badge-success">Ativo</span>}</td>
                <td>{u.tipo_usuario}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => { setEditando(u); setForm({ nome: u.nome, email: u.email, whatsapp: u.whatsapp }); }}>Editar</button>
                    {u.bloqueado
                      ? <button className="btn btn-success" onClick={() => desbloquear(u.id)}>Desbloquear</button>
                      : <button className="btn btn-danger" onClick={() => bloquear(u.id)}>Bloquear</button>}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
